import { useState } from 'react';

import { isValidPhoneNumber } from 'libphonenumber-js';

import { PhoneField } from '@components/phone-field';
import { useScopedTranslate } from '@locale/translate';

import { EditableCellPopover, FieldEditorBody } from './editable-cell-popover';
import { editableCellLocale } from './locale';
import { EditableCellEditorProps } from './types';
import { useEditableCellTrigger } from './use-editable-cell-trigger';

import { typeRenderMap } from '../renderers';

type EditablePhoneCellProps = EditableCellEditorProps<string | undefined>;

export const EditablePhoneCell = ({ column, row, value }: EditablePhoneCellProps) => {
  const { t } = useScopedTranslate(editableCellLocale);
  const getTrigger = useEditableCellTrigger();
  const [draft, setDraft] = useState(value ?? '');

  const validationError =
    draft !== '' && !isValidPhoneNumber(draft, 'IS') ? t('invalidPhoneNumber') : undefined;

  const trigger = getTrigger(value, column, row, () =>
    typeRenderMap.phone_number(value, column, row)
  );

  return (
    <EditableCellPopover
      trigger={trigger}
      column={column}
      row={row}
      value={value}
      validationError={validationError}
      isValidationErrorInField
      onOpen={() => setDraft(value ?? '')}
      isSaveDisabled={draft === (value ?? '')}
      onSave={async () => {
        await column.onEdit?.(row, draft);
      }}
    >
      <FieldEditorBody>
        <PhoneField
          label={column.title}
          defaultValue={value ?? ''}
          onChange={setDraft}
          error={validationError}
          portal
          isAutoFocused
        />
      </FieldEditorBody>
    </EditableCellPopover>
  );
};
